export const environment = {
  production: true,
  API_ENDPOINT: 'https://mgk1mbcg72.execute-api.eu-west-1.amazonaws.com/staging/api/',
  BASE_URL: 'https://mgk1mbcg72.execute-api.eu-west-1.amazonaws.com/staging/api/v1',
  API_KEY: 'wVSy52q459410BqiQp2E41g2BrBvbtk87Okgm5MU'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts